import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createTopic } from '../../slices/topicsSlice';

const TopicCreate = () => {
  const [mainTitle, setMainTitle] = useState('');
  const [blueTeam, setBlueTeam] = useState('');
  const [redTeam, setRedTeam] = useState('');

  // 🚩 [추가] 링크 상태 관리
  const [linkTitle, setLinkTitle] = useState('');
  const [linkUrl, setLinkUrl] = useState('');
  
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const combinedTitle = `${mainTitle}\n${blueTeam} VS ${redTeam}`;
    
    // 🚀 서버의 TopicSchema 구조와 일치시킵니다.
    const newTopic = { 
      title: combinedTitle, 
      externalLinks: linkTitle ? [{ linkTitle, url: linkUrl }] : [],
      gauge: {
        blue: 50, // 초기값 설정
        red: 50
      },
      history: []
    };

    const result = await dispatch(createTopic(newTopic));
    
    if (result.meta.requestStatus === 'fulfilled') {
      alert("새로운 전장이 선포되었습니다!");
      navigate('/topics');
    } else {
      alert("전장 생성에 실패했습니다.");
    }
  };

return (
    <div style={{ padding: '40px', color: 'white', background: '#121212', minHeight: '100vh' }}>
      <h2 style={{ borderBottom: '2px solid #E50914', paddingBottom: '10px' }}>⚔️ 새 전장 선포</h2>
      
      <form onSubmit={handleSubmit} style={{ marginTop: '30px', maxWidth: '500px' }}>
        {/* 1. 메인 주제 */}
        <div style={{ marginBottom: '25px' }}>
          <label style={{ fontWeight: 'bold', color: '#888' }}>1. 전장 분류 (메인 주제)</label>
          <input 
            type="text" 
            value={mainTitle} 
            onChange={(e) => setMainTitle(e.target.value)} 
            placeholder="예: 평생 하나만 먹는다면?"
            style={inputStyle}
            required 
          />
        </div>

        {/* 2. 진영 설정 */}
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '10px' }}>
          <div style={{ flex: 1 }}>
            <label style={{ fontWeight: 'bold', color: '#00d4ff' }}>BLUE 진영</label>
            <input 
              type="text" 
              value={blueTeam} 
              onChange={(e) => setBlueTeam(e.target.value)} 
              placeholder="예: 짜장면"
              style={{ ...inputStyle, width: '80%', border: '1px solid #00d4ff' }}
              required 
            />
          </div>
          
          <span style={{ marginTop: '25px', fontWeight: 'bold' }}>VS</span>

          <div style={{ flex: 1 }}>
            <label style={{ fontWeight: 'bold', color: '#ff4e50' }}>RED 진영</label>
            <input 
              type="text" 
              value={redTeam} 
              onChange={(e) => setRedTeam(e.target.value)} 
              placeholder="예: 짬뽕"
              style={{ ...inputStyle, width: '80%', border: '1px solid #ff4e50' }}
              required 
            />
          </div>
        </div>
        
        <p style={{ color: '#666', fontSize: '0.85rem', marginBottom: '30px' }}>
          * 입력하신 내용은 상세 페이지에서 화려한 대결 구도로 표시됩니다.
        </p>

        {/* 3. [추가] 외부 링크 설정 */}
        <div style={{ marginBottom: '25px', padding: '15px', background: '#1a1a1a', borderRadius: '4px' }}>
          <label style={{ fontWeight: 'bold', color: '#888' }}>3. 참고 문헌/외부 링크 (선택)</label>
          <input 
            type="text" 
            placeholder="링크 제목 (예: 관련 뉴스 보기)" 
            value={linkTitle}
            onChange={e => setLinkTitle(e.target.value)}
            style={inputStyle} 
          />
          <input 
            type="text" 
            placeholder="URL 주소 (https://...)" 
            value={linkUrl}
            onChange={e => setLinkUrl(e.target.value)}
            style={{...inputStyle, marginTop: '10px'}} 
          />
        </div>

        <button type="submit" style={submitButtonStyle}>
          전장 선포하기 (DEPLOY)
        </button>
      </form>
    </div>
  );
};

// 스타일 재사용
const inputStyle = {
  width: '100%', 
  padding: '12px', 
  marginTop: '8px', 
  background: '#222', 
  color: 'white', 
  border: '1px solid #444',
  borderRadius: '4px'
};

const submitButtonStyle = {
  width: '100%',
  padding: '15px', 
  background: '#E50914', 
  color: 'white', 
  border: 'none', 
  cursor: 'pointer', 
  fontWeight: 'bold',
  fontSize: '1.1rem',
  borderRadius: '4px',
  boxShadow: '0 4px 15px rgba(229, 9, 20, 0.4)'
};

export default TopicCreate;